import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { InventorizeReviewField } from '@/features/inventorization/domain/review/inventorize-review-fields';
import { isFilledStatus } from '@/features/inventorization/review/register-review-model';
import type { LocalPhotoRef } from '@/shared/capture/capture-session';

export function RegisterProgress({ fields, photos }: { fields: InventorizeReviewField[]; photos: LocalPhotoRef[] }) {
  const filled = fields.filter(field => isFilledStatus(field.status)).length + (photos.length > 0 ? 1 : 0);
  const total = fields.length + 1;
  const requiredComplete =
    photos.length > 0 && fields.filter(field => field.required).every(field => isFilledStatus(field.status));

  return (
    <Tag
      color={requiredComplete ? 'green' : 'orange'}
      icon={requiredComplete ? <CheckCircleOutlined /> : <ExclamationCircleOutlined />}
    >
      {filled}/{total}
    </Tag>
  );
}
